import Vue from 'vue';
import Vue2Storage from 'vue2-storage';

Vue.use(Vue2Storage);
export default {
    mutations: {
        setRegisterData(state, data) {
            if (data.id) state.id = data.id;
            if (data.password) state.password = data.password;
            if (data.phone_verified_at) state.phone_verified_at = data.phone_verified_at;
            if (data.last_code) state.last_code = data.last_code;
        },
        clearRegisterData(state) {
            state.id = null;
            state.password = null;
            state.phone_verified_at = null;
            state.last_code = null;
        }
    },
    state: {
        id: null,
        password: false,
        phone_verified_at: null,
        last_code: null,
    },
    getters: {
        getRegisterData(state){
            return {
                id: state.id,
                password: state.password,
                phone_verified_at: state.phone_verified_at,
                last_code: state.last_code,
            }
        }
    }
}